<template>
  <div class="content">
    <div class="container-fluid">

      <div class="row">
        <h3>404</h3>
        <div>
          Path not found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
